module.exports = __webpack_public_path__ + "img/euro-sign.56217457.svg";